import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { db } from '../firebase';
import {
  collection, addDoc, deleteDoc, doc, serverTimestamp, updateDoc, increment
} from 'firebase/firestore';

export const addPostToDb = createAsyncThunk('profile/addPost', async ({ text, topicId, file, eventDate, eventTime, taggedUsers, taggedGroups, replyTo }, { getState, rejectWithValue }) => {
  try {
    const user = getState().auth.user;
    await addDoc(collection(db, 'posts'), {
      text: text,
      topicId: topicId || null,
      fileName: file ? file.fileName : null,
      fileType: file ? file.fileType : null,
      fileData: file ? file.fileData : null,
      eventDate: eventDate || null,
      eventTime: eventTime || null,
      taggedUsers: taggedUsers || [],
      taggedGroups: taggedGroups || [],
      replyTo: replyTo || null,
      createdAt: serverTimestamp(),
      authorId: user ? user.uid : null,
      authorEmail: user ? user.email : 'Аноним',
      authorName: user ? (user.displayName || user.email) : 'Аноним',
    });

    const authorName = user ? (user.displayName || user.email) : 'Аноним';
    const dateSuffix =
      (eventDate ? ` 📅 ${eventDate.split('-').reverse().join('.')}` : '') +
      (eventTime ? ` ⏰ ${eventTime}` : '');

    // Отмеченным пользователям — в личные сообщения
    if (user && Array.isArray(taggedUsers) && taggedUsers.length > 0) {
      const note = `🔖 ${authorName} отметил(а) вас в посте: «${text}»${dateSuffix}`;
      for (const uid of taggedUsers) {
        if (uid === user.uid) continue;
        const chatId = [user.uid, uid].sort().join('_');
        await addDoc(collection(db, 'chats', chatId, 'messages'), {
          type: 'text', text: note,
          from: user.uid, fromEmail: user.email,
          to: uid, read: false, createdAt: serverTimestamp(),
        });
        await updateDoc(doc(db, 'users', uid), {
          [`unreadFrom.${user.uid}`]: increment(1),
        });
      }
    }

    // Отмеченным группам — дубликат в ленту группы
    if (user && Array.isArray(taggedGroups) && taggedGroups.length > 0) {
      for (const gid of taggedGroups) {
        await addDoc(collection(db, 'groups', gid, 'posts'), {
          text: `📢 ${authorName} (из ленты): «${text}»${dateSuffix}`,
          fileName: file ? file.fileName : null,
          fileType: file ? file.fileType : null,
          fileData: file ? file.fileData : null,
          authorId: user.uid,
          authorEmail: user.email,
          authorName: authorName,
          groupId: gid,
          fromFeed: true,
          createdAt: serverTimestamp(),
        });
      }
    }
    return true;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

export const deletePostFromDb = createAsyncThunk('profile/deletePost', async (postId, { rejectWithValue }) => {
  try {
    await deleteDoc(doc(db, 'posts', postId));
    return postId;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

const initialState = {
  posts: [],
  newPostText: '',
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    updateNewPostText: (state, action) => {
      state.newPostText = action.payload;
    },
    setPosts: (state, action) => {
      state.posts = Array.isArray(action.payload) ? action.payload : [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(addPostToDb.fulfilled, (state) => {
      state.newPostText = '';
    });
  },
});

export const { updateNewPostText, setPosts } = profileSlice.actions;
export default profileSlice.reducer;